import type { onBeforeSaveType, onAfterSaveType } from 'app/main/components/hooks/useModel';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

export default {};
